<form *ngIf="orderForm" [formGroup]="orderForm" (ngSubmit)="onSubmit()" class="content-card">
  <mat-card class="form-card">
    <mat-card-content>
      <mat-form-field>
        <input matInput placeholder="ExternalRef" formControlName="externalRef" readonly required>
      </mat-form-field>
      <mat-form-field>
        <input matInput placeholder="Card name" formControlName="cardName" maxlength="19" pattern="[a-zA-Z'-\s]*" required>
      </mat-form-field>
      <mat-form-field>
        <input matInput placeholder="Sex" formControlName="sex" required>
      </mat-form-field>
      <mat-form-field>
        <input matInput placeholder="Title" formControlName="title" required>
      </mat-form-field>
      <mat-form-field>
        <input matInput placeholder="First Name" formControlName="firstName" pattern="[a-zA-Z'-\s]*" maxlength="50" required>
      </mat-form-field>
      <mat-form-field>
        <input matInput placeholder="Last Name" formControlName="lastName" pattern="[a-zA-Z'-\s]*" maxlength="50" required>
      </mat-form-field>
      <app-date-edit placeholder="Date of birth" formControlName="dob" required></app-date-edit>
      <mat-form-field>
        <input matInput placeholder="Email" formControlName="email" maxlength="60" required>
      </mat-form-field>
      <mat-form-field>
        <input matInput placeholder="Mobile" formControlName="phone" minlength="9" maxlength="15" required>
      </mat-form-field>
      <mat-form-field>
        <mat-select placeholder="Product" formControlName="productId">
          <mat-option *ngFor="let product of products" [value]="product.id">{{product.name}}</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field>
        <mat-select placeholder="Country" formControlName="countryIsoCode">
          <mat-option *ngFor="let country of countries" [value]="country.isoCode">{{country.name}}</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field>
        <input matInput placeholder="Address" formControlName="address" maxlength="50" required>
      </mat-form-field>
      <mat-form-field>
        <input matInput placeholder="City" formControlName="city" maxlength="50" required>
      </mat-form-field>
      <mat-form-field>
        <input matInput placeholder="Zip Code" formControlName="zipCode" maxlength="50" required>
      </mat-form-field>
      <mat-form-field>
        <input matInput placeholder="Nationality" formControlName="nationality" required>
      </mat-form-field>
      <mat-form-field>
        <input matInput placeholder="Ip Address" formControlName="ipAddress" readonly required>
      </mat-form-field>
      <app-date-edit placeholder="Order date" formControlName="orderDate" [readOnly]=true required></app-date-edit>
      <mat-form-field>
        <mat-select placeholder="Order language" formControlName="orderLanguage" required>
          <mat-option [value]="0">german</mat-option>
          <mat-option [value]="1">english</mat-option>
        </mat-select>
      </mat-form-field>
    </mat-card-content>
    <mat-card-actions align="end">
      <button mat-raised-button color="accent" type="button" (click)="returnBack()">Cancel</button>
      <button mat-raised-button color="primary" type="submit" [disabled]="!orderForm.valid">Save</button>
    </mat-card-actions>
  </mat-card>
</form>
